import PropTypes from 'prop-types';
import {createUseStyles} from 'react-jss';
import Spacing from '../../v2/style-helper/Spacing';
import replaceHTMLEntityWithSymbol from '../../v2/utils/replace-html-entity-with-symbol';
import Translation from '../../v2/lang/Translation';

const useStyles = createUseStyles({
  tableWrapper: {
    borderBottom: '2px solid #F2F2F2',
    paddingBottom: Spacing.double,
    marginBottom: 20,
  },
  table: {
    width: '100%',
  },
  tableHead: {
    backgroundColor: '#F2F2F2',
  },
  tableHeader: {
    textAlign: 'left',
    paddingLeft: Spacing.single,
    paddingTop: Spacing.single,
    width: '40%',
  },
  center: {
    textAlign: 'center',
  },
});

export function SubscriptionInformationTable(props) {
  const classes = useStyles({...props});
  const subscriptionItemList = props.basketItems?.filter(option => option.subscriptionBySku);
  
  const desktopSubscriptionTable = (
    <table border="1">
      <thead className={classes.tableHead}>
        <tr>
          <th className={classes.tableHeader}>
            <Translation>checkout.subscription.information.section.table.heading.productName</Translation>
          </th>
          <th className={classes.tableHeader}>
            <Translation>checkout.subscription.information.section.table.heading.quantity</Translation>
          </th>
          <th className={classes.tableHeader}>
            <Translation>checkout.subscription.information.section.table.heading.frequency</Translation>
          </th>
          <th className={classes.tableHeader}>
            <Translation>checkout.subscription.information.section.table.heading.firstDeliveryPrice</Translation>
          </th>
          <th className={classes.tableHeader}>
            <Translation>checkout.subscription.information.section.table.heading.recurringPrice</Translation>
          </th>
        </tr>
      </thead>
      <tbody data-test="SubscriptionInformationTable__dataTable">
        {subscriptionItemList?.map((item, index) => (
          <tr data-test={`SubscriptionInformationTable__dataTable__row--${index}`}>
            <td>{item.productTitle}</td>
            <td className={classes.center} data-test={`SubscriptionInformationTable__dataTable__row--${index}--quantity`} data-value={item?.quantity}>{item.quantity}</td>
            <td className={classes.center} data-test={`SubscriptionInformationTable__dataTable__row--${index}--frequencyDuration`} data-value={item?.subscriptionBySkuMetadata?.frequencyDuration}>{item.subscriptionBySkuMetadata?.frequencyDuration}</td>
            <td className={classes.center} data-test={`SubscriptionInformationTable__dataTable__row--${index}--initialPrice`} data-value={item?.totalChargePrice?.value}>{replaceHTMLEntityWithSymbol(item.totalChargePrice?.formatted)}</td>
            <td className={classes.center} data-test={`SubscriptionInformationTable__dataTable__row--${index}--recurringPrice`} data-value={item?.subscriptionBySkuMetadata?.totalRecurringPrice?.value}>{replaceHTMLEntityWithSymbol(item.subscriptionBySkuMetadata?.totalRecurringPrice?.formatted)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
  
  const mobileSubscriptionTable = (
    <div data-test="SubscriptionInformationTable__dataTable">
      {subscriptionItemList?.map((item, index) => (
        <div className={classes.tableWrapper} data-test={`SubscriptionInformationTable__dataTable__row--${index}`}>
          <table className={classes.table} border="1">
            <thead className={classes.tableHead}>
              <tr>
                <th className={classes.tableHeader}>
                  <Translation>checkout.subscription.information.section.table.heading.productName</Translation>
                </th>
                <td>{item.productTitle}</td>
              </tr>
            </thead>
          
            <tbody>
              <tr>
                <th className={classes.tableHeader}>
                  <Translation>checkout.subscription.information.section.table.heading.quantity</Translation>
                </th>
                <td
                  data-test={`SubscriptionInformationTable__dataTable__row--${index}--quantity`}
                  data-value={item?.quantity}
                >
                  {item.quantity}</td>
              </tr>
            </tbody>
          
            <thead className={classes.tableHead}>
              <tr>
                <th className={classes.tableHeader}>
                  <Translation>checkout.subscription.information.section.table.heading.frequency</Translation>
                </th>
                <td
                  data-test={`SubscriptionInformationTable__dataTable__row--${index}--frequencyDuration`}
                  data-value={item.subscriptionBySkuMetadata?.frequencyDuration}
                >
                  {item.subscriptionBySkuMetadata?.frequencyDuration}</td>
              </tr>
            </thead>
          
            <tbody>
              <tr>
                <th className={classes.tableHeader}>
                  <Translation>checkout.subscription.information.section.table.heading.firstDeliveryPrice</Translation>
                </th>
                <td
                  data-test={`SubscriptionInformationTable__dataTable__row--${index}--initialPrice`}
                  data-value={item?.totalChargePrice?.value}
                >
                  {replaceHTMLEntityWithSymbol(item.totalChargePrice?.formatted)}
                </td>
              </tr>
            </tbody>
          
            <thead className={classes.tableHead}>
              <tr>
                <th className={classes.tableHeader}>
                  <Translation>checkout.subscription.information.section.table.heading.recurringPrice</Translation>
                </th>
                <td
                  data-test={`SubscriptionInformationTable__dataTable__row--${index}--recurringPrice`}
                  data-value={item?.subscriptionBySkuMetadata?.totalRecurringPrice?.value}
                >
                  {replaceHTMLEntityWithSymbol(item.subscriptionBySkuMetadata?.totalRecurringPrice?.formatted)}
                </td>
              </tr>
            </thead>
          </table>
        </div>
      ))}
    </div>
  );
  
  return props.isMobile ? mobileSubscriptionTable : desktopSubscriptionTable;
}

SubscriptionInformationTable.propTypes = ({
  basketItems: PropTypes.arrayOf(PropTypes.shape({
    productTitle: PropTypes.string,
    quantity: PropTypes.number,
    subscriptionBySkuMetadata: PropTypes.shape({
      frequencyDuration: PropTypes.number,
      recurringPrice: PropTypes.shape({
        formatted: PropTypes.string,
      }),
    }),
  })),
  isMobile: PropTypes.bool,
});

export default SubscriptionInformationTable;
